(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('cloud-pbx-prefix', {
            /*
            parent: 'entity',
            */
            parent: 'dictionary',
            url: '/cloud-pbx-prefix?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.cloudPBXPrefix.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/cloud-pbx-prefix/cloud-pbx-prefixes.html',
                    controller: 'CloudPBXPrefixController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('cloudPBXPrefix');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('cloud-pbx-prefix-detail', {
            parent: 'cloud-pbx-prefix',
            url: '/cloud-pbx-prefix/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.cloudPBXPrefix.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/cloud-pbx-prefix/cloud-pbx-prefix-detail.html',
                    controller: 'CloudPBXPrefixDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('cloudPBXPrefix');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CloudPBXPrefix', function($stateParams, CloudPBXPrefix) {
                    return CloudPBXPrefix.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'cloud-pbx-prefix',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('cloud-pbx-prefix-detail.edit', {
            parent: 'cloud-pbx-prefix-detail',
            url: '/detail/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cloud-pbx-prefix/cloud-pbx-prefix-dialog.html',
                    controller: 'CloudPBXPrefixDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CloudPBXPrefix', function(CloudPBXPrefix) {
                            return CloudPBXPrefix.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('cloud-pbx-prefix.new', {
            parent: 'cloud-pbx-prefix',
            url: '/new',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cloud-pbx-prefix/cloud-pbx-prefix-dialog.html',
                    controller: 'CloudPBXPrefixDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                prefix: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('cloud-pbx-prefix', null, { reload: 'cloud-pbx-prefix' });
                }, function() {
                    $state.go('cloud-pbx-prefix');
                });
            }]
        })
        .state('cloud-pbx-prefix.edit', {
            parent: 'cloud-pbx-prefix',
            url: '/{id}/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cloud-pbx-prefix/cloud-pbx-prefix-dialog.html',
                    controller: 'CloudPBXPrefixDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CloudPBXPrefix', function(CloudPBXPrefix) {
                            return CloudPBXPrefix.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('cloud-pbx-prefix', null, { reload: 'cloud-pbx-prefix' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('cloud-pbx-prefix.delete', {
            parent: 'cloud-pbx-prefix',
            url: '/{id}/delete',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cloud-pbx-prefix/cloud-pbx-prefix-delete-dialog.html',
                    controller: 'CloudPBXPrefixDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CloudPBXPrefix', function(CloudPBXPrefix) {
                            return CloudPBXPrefix.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('cloud-pbx-prefix', null, { reload: 'cloud-pbx-prefix' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
